import React from "react";
import APIDefinitions from "../../yoello-lib/modules/API2/APIDefs";
import { feeColumns } from "./columns";
import { ITaxesItems, TaxesItems } from "./TaxesItems";



export function TaxesFeeItems(props: ITaxesItems) {
    return <TaxesItems {...props} taxType="venue_fees" columns={feeColumns} APIDefintion={APIDefinitions.venueFees}
        emptyListTitle="taxes.dialog.emptyListFee"
        emptyListInfo="taxes.dialog.emptyListFeeInfo" />;
}